import { Box, Typography } from '@mui/material';
import { memo, useEffect } from 'react';

import packageJson from '../../../../../../../../../package.json';
import { getCurrentYear } from '../../../../../../../../constants/helpers/dates';

interface Props {
  handleUnlock: () => void;
}

const About = ({ handleUnlock }: Props) => {
  useEffect(() => {
    handleUnlock();
  });

  return (
    <Box>
      <Typography variant="h3">{packageJson.description}</Typography>
      <Box mt={1}>
        <Typography variant="body1">
          Developer Portal allows you to monitor the usage of Qrios API services and manage the services from
          perspective of a developer.
        </Typography>
      </Box>
      <Box mt={1}>
        <Typography variant="body1">
          Qrios API exposes a bunch of operations, which can be used by third party applications. Each API call may
          generate cost which will be covered by funds from your wallet. To monitor a consumption of funds and a wallet
          condition, you can use Developer Portal.
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography variant="body1" align="center">
          {`${packageJson.description} (v${packageJson.version})`}
        </Typography>
        <Typography variant="body1" align="center">
          © 2021 - {getCurrentYear()} Qrios, Inc, All rights reserved
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(About);
